module.exports = __webpack_public_path__ + "img/tbi.48e6e342.jpg";